//Contracts:
import { particles } from 'app/contracts/Particles';
//Library:
import { Particle } from 'particles/Particle';
import { ParticleProgressParallax } from 'particles/behaviour/ParticleProgressParallax';
import { ParticleMouseParallax } from 'particles/behaviour/ParticleMouseParallax';
import DelayHelper from 'utils/timers';

export class SpacesGridParticle extends Particle {
	private _mouseParallax: ParticleMouseParallax;

	//OVERRIDED FROM BASE:
	//-------------------------------------------------------------------------------------------------------

	protected createBehaviours(config: particles.ParticleConfig): void {
		//Only a small range of particles need to be attracted to the intro

		//Add the parallax position controller:
		this._position = this._behaviourManager.add(ParticleProgressParallax);

		//Mouse parallax on particles:
		this._mouseParallax = this._behaviourManager.add(ParticleMouseParallax);

		this._mouseParallax.active = true;
		this._mouseParallax.setup({ ease: { x: 20, y: 20 }, power: { x: 0.05, y: 0.05 } });

		this._setState();
	}

	public setTint(colour) {
		this._tint.tween(colour, 0.4);
	}

	//PRIVATE METHODS
	//--------------------------------------------------------------------------------------------------

	private _setState(): void {
		this.setMouseParallaxByScale();
		this._mouseParallax.active = true;
		this._tint.set(0xffffff);

		DelayHelper.setTimeout(() => {
			this.setMouseParallaxByScale();
		}, 2000);
	}

	public setMouseParallaxByScale(): void {
		this._animatedProps.setEase({
			x: this._animatedProps.targetScale * 10,
			y: this._animatedProps.targetScale * 50,
			scale: this._animatedProps.targetScale * 50
		});

		(this._position as ParticleProgressParallax).power = 1.5 * this._animatedProps.targetScale;

		let easeUp = 1 - this._animatedProps.targetScale / 0.4;

		this._mouseParallax.setup({
			ease: { x: 10 + 30 * easeUp, y: 10 + 30 * easeUp },
			power: { x: 0.1 * this._animatedProps.targetScale, y: 0.16 * this._animatedProps.targetScale }
		});
	}
}
